import React, { useState } from "react";
import { Routes, Route, Link } from "react-router-dom"; // Added Link import
import AuthModal from "./components/AuthModal";
import HomePage from "./pages/HomePage";
import Navbar from "./components/Navbar";
import PostItem from "./pages/PostItem"; // Make sure this exists
import NearbyItems from "./pages/NearbyItems";
import './App.css'; // Import your CSS file

const App = () => {
  const [showModal, setShowModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
      <Navbar 
        isAuthenticated={isAuthenticated}
        setIsAuthenticated={setIsAuthenticated}
        setShowModal={setShowModal}
      />
      
      <main className="container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/post" element={<PostItem />} />
          <Route path="/nearby" element={<NearbyItems />} />
        </Routes>
      </main>

      <AuthModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        setIsAuthenticated={setIsAuthenticated}
      />
    </div>
  );
};

export default App;